import { apiSlice } from "../../../features/api/apiSlice";

// Reuse your helper functions for consistent data extraction
function pick(res: any) {
  return res?.data?.data ?? res?.data ?? res;
}

function pickArray(res: any) {
  const d = pick(res);
  if (Array.isArray(d)) return d;
  if (Array.isArray(d?.data)) return d.data;
  if (Array.isArray(res?.data)) return res.data;
  return [];
}

export const settingsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStates: builder.query<any[], void>({
      query: () => "/states",
      transformResponse: (res: any) => pickArray(res),
    }),
    getChapters: builder.query<any[], void>({
      query: () => "/chapters",
      transformResponse: (res: any) => pickArray(res),
    }),
    getSectors: builder.query<any[], void>({
      query: () => "/sectors",
      transformResponse: (res: any) => pickArray(res),
    }),
    // Keep LGAs dynamic based on State if your API supports it

    getLgas: builder.query<any[], number | string | void>({
      query: (stateId) => `/v1/states/${stateId}/lgas`,
      transformResponse: (res: any) => pickArray(res),
    }),
    getActiveUserCategories: builder.query<any, void>({
      // Prefix is 'user-categories', route is 'active' -> Total: /user-categories/active
      query: () => "/user-categories/active",
      transformResponse: (res: any) => pickArray(res),
    }),
    getChapterLeadership: builder.query<{
      chairman: { id: string; name: string; email: string; phone?: string } | null;
      secretary: { id: string; name: string; email: string; phone?: string } | null;
    }, string>({
      query: (chapterId) => `/chapters/${chapterId}/leadership`,
      transformResponse: (res: any) => pick(res),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetStatesQuery,
  useGetChaptersQuery,
  useGetSectorsQuery,
  useGetLgasQuery,
  useGetActiveUserCategoriesQuery,
  useGetChapterLeadershipQuery,
  useLazyGetChapterLeadershipQuery,
} = settingsApi;
